<section class="checkout-page">
	<div class="checkout-card">
		@if (paymentBanner()) {
		<div class="banner banner-success" role="status" aria-live="polite">
			{{ paymentBanner() }}
		</div>
		}
		<form [formGroup]="form" (ngSubmit)="submit()" novalidate>
			<div class="form-row">
				<label>{{'Email' | translate}}</label>
				<input type="email" formControlName="email" placeholder="{{'you@example.com' | translate}}"
					[readOnly]="true" />
				@if (form.get('email')?.invalid && form.get('email')?.touched) {
				<div class="field-error">Valid email is required.</div>
				}
			</div>
			<div class="grid">
				<div class="form-row">
					<label>{{'First_Name' | translate}}</label>
					<input type="text" formControlName="firstName" placeholder="{{'First_Name' | translate}}"
						title="{{'First_Name' | translate}}" />
				</div>
				<div class="form-row">
					<label>{{'Last_Name' | translate}}</label>
					<input type="text" formControlName="lastName" placeholder="{{'Last_Name' | translate}}"
						title="{{'Last_Name' | translate}}" />
				</div>
			</div>
			<div class="grid">
				<div class="form-row">
					<label>{{'Phone_Number' | translate}}</label>
					<input type="tel" formControlName="phone" placeholder="{{'Phone_Number' | translate}}"
						title="{{'Phone_Number' | translate}}" />
				</div>
				<div class="form-row">
					<label>{{'Password' | translate}}</label>
					<input type="password" formControlName="password" placeholder="{{'Password' | translate}}"
						title="{{'Password' | translate}}" />
					@if (form.get('password')?.invalid && form.get('password')?.touched) {
					<div class="field-error">
						{{'PASSWORD_REQUIREMENTS' | translate}}
					</div>
					}
				</div>
			</div>
			<div class="form-row">
				<label>{{'Website_Name' | translate}}</label>
				<input type="text" formControlName="webSiteName" placeholder="{{'YourBrand' | translate}}" />
			</div>

			<button class="submit-btn" type="submit" [disabled]="form.invalid || submitting()">{{'Submit' |
				translate}}</button>
		</form>
	</div>
</section>